import { INavigationEntry } from '@types'
import { rootUrl, routes } from '@navigation/route-declarations'
import { useLocation, useNavigate } from 'react-router'
import { useEffect } from 'react'
import { searchInPath } from '@utils'

type IColumnsOfEntries = {
  entries: Array<INavigationEntry>
  config: { iconColor?: string }
}

export const useNavigationEntries = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    redirectToProject()
  }, [])

  const redirectToProject = () => {
    if (searchInPath(rootUrl.navigate(), location.pathname)) {
      navigate(routes.projects.navigate())
    }
  }

  const firstColumn: IColumnsOfEntries = {
    entries: [
      /* HIDE
			 * {
				icon: "Speedometer02",
				title: "Dashboard",
				subtitle: "Insert subtitle",
				to: routes.dashboard.navigate(),
				isActive: (pathname) => pathname === routes.dashboard.navigate(),
				iconColor: "#15B79E",
			},*/
      {
        icon: 'BarLineChart',
        title: 'Projets',
        route: 'projects',
        subtitle: 'Insert subtitle',
        iconColor: '#15B79E',
        to: routes.projects.navigate(),
        isActive: (pathname) => pathname.includes('project'),
      },
      {
        icon: 'User01',
        title: 'Certifications',
        route: 'certifications',
        subtitle: 'Insert subtitle',
        iconColor: '#15B79E',
        to: routes.certifications.navigate(),
        isActive: (pathname) => pathname.includes('certification'),
      },
    ],
    config: { iconColor: '#15B79E' },
  }

  const secondColumn: IColumnsOfEntries = {
    entries: [
      {
        route: 'contributors',
        title: 'Contributions',
        icon: 'Users01',
        subtitle: 'Insert subtitle',
        to: routes.contributors.navigate(),
        isActive: (pathname) => pathname.includes('contributor'),
        iconColor: '#2E90FA',
      },
      {
        title: 'Informations',
        route: 'informations',
        icon: 'CheckVerified03',
        subtitle: 'Insert subtitle',
        to: routes.informations.navigate(),
        isActive: (pathname) => pathname.includes(routes.informations.navigate()),
        iconColor: '#2E90FA',
      },
      // TODO HIDE - don't delete
      // {
      //   title: 'Activity',
      //   icon: 'Target03',
      //   subtitle: 'Insert subtitle',
      //   to: routes.activity.navigate(),
      //   isActive: (pathname) => pathname.includes(routes.activity.navigate()),
      //   iconColor: '#2E90FA',
      // },
    ],
    config: { iconColor: '#2E90FA' },
  }

  return {
    firstColumn,
    secondColumn,
  }
}
